import global from '@assets/css/global.css';

/**
 * Shared styles for the application.
 * @type {CSSStyleSheet}
 */
export const globalSharedStyles = new CSSStyleSheet();
globalSharedStyles.replaceSync(global);
